export enum NftStatusEnum {
  PENDING = 'PENDING',
  TRANSFERRING = 'TRANSFERRING',
  TRANSFERRED = 'TRANSFERRED',
  FAILED = 'FAILED'
}
